import React, { useState } from 'react';
import {
  Grid,
  TextField
} from '@material-ui/core';
import BorderRadiusPickerDialog from './pickers/BorderRadiusPickerDialog';


const BorderSelectorGrid = ({
  name,
  label,
  value,
  InputProps = {},
  classes = '',
  setValue
}) => {
  const [showBorderRadiusPicker, setShowBorderRadiusPicker] = useState(false);

  return (
    <Grid container spacing={3} className="pr-2 ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6}>
        <TextField
          variant="outlined"
          color="primary"
          fullWidth
          className={classes}
          name={name}
          label={label}
          defaultValue={value}
          InputProps={InputProps}
          onClick={() => setShowBorderRadiusPicker(!showBorderRadiusPicker)}
        />
        {showBorderRadiusPicker &&
          <BorderRadiusPickerDialog
            value={value}
            setShowBorderRadiusPicker={setShowBorderRadiusPicker}
            onChange={setValue}
          />
        }
      </Grid>
    </Grid>
  );
};

export default BorderSelectorGrid;
